/**
 * Linear-time positive number string checks (avoids ReDoS-prone regex).
 * Accepts empty string (cleared inputs), integers, and decimals with at most one dot.
 */
class PositiveNumberHelper {
  static isPositiveNumberInput(value) {
    if (value === '') {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }

    let seenDot = false;
    let digitCount = 0;

    for (let i = 0; i < value.length; i += 1) {
      const char = value[i];
      if (char === '.') {
        if (seenDot) {
          return false;
        }
        seenDot = true;
      } else if (char >= '0' && char <= '9') {
        digitCount += 1;
      } else {
        return false;
      }
    }

    return digitCount > 0 && value[value.length - 1] !== '.';
  }
}

export default PositiveNumberHelper;
